import {IHolidayCalendarData, holidayCalendarActionTypes, UPDATE_HOLIDAY_CALENDAR} from './types';

const initialState: IHolidayCalendarData = {
  template: null,
  success: false,
};

export default function hotelsHolidayCalendarReducer(
  state = initialState,
  action: holidayCalendarActionTypes,
) {
  switch (action.type) {
    case UPDATE_HOLIDAY_CALENDAR:
      return {
        ...state,
        template: action.actionData.template,
        success: action.actionData.success,
      };

    default:
      return state;
  }
}
